import React from 'react';
import { Route, BrowserRouter as Router, Routes } from 'react-router-dom';
import PrivateRoute from './components/PrivateRoute';
import BankContainer from './containers/BankContainer';
import TransactionsContainer from './containers/TransactionsContainer';
import WelcomePageContainer from './containers/WelcomePageContainer';
import WhatsappContainer from './containers/WhatsappContainer';
import { AuthProvider } from './hooks/AuthContext';
import { TransactionsProvider } from './hooks/TransactionsContext';

const App = () => {
  return (
    <AuthProvider>
      <TransactionsProvider>
        <Router>
          <Routes>
            <Route path="/" element={<WelcomePageContainer />} />
            <Route
              path="/dashboard"
              element={
                <PrivateRoute>
                  <TransactionsContainer />
                </PrivateRoute>
              }
            />
            <Route
              path="/whatsapp"
              element={
                <PrivateRoute>
                  <WhatsappContainer />
                </PrivateRoute>
              }
            />
            <Route
              path="/bank"
              element={
                <PrivateRoute>
                  <BankContainer />
                </PrivateRoute>
              }
            />
          </Routes>
        </Router>
      </TransactionsProvider>
    </AuthProvider>
  );
};

export default App;
